import { ANALYTICS_DASHBOARD_ROUTE_NAME } from '@/router/router.const.js';
import CreateAndManageService from '@/views/AppLayout/ManageAndCreate/create-and-manage-service.js';

const getSubPageTitle = (currentRoute) => currentRoute?.meta?.title;
const isAnalyticsDashboard = (currentRoute) => CreateAndManageService.isRouteOrChildOfRoute(currentRoute, ANALYTICS_DASHBOARD_ROUTE_NAME);

const AnalyticsService = {
	getSubPageTitle,
	isAnalyticsDashboard,
};
export default AnalyticsService;
